import { IsBoolean, IsString } from 'class-validator';

export class AdminImportModulesDto {
  @IsBoolean()
  dryRun: boolean;

  @IsString()
  filePaths: string;

  @IsString()
  importFilenamePrefix: string;

  @IsBoolean()
  autoApprove: boolean;
}
